import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import { propArrayShape, propBool } from '../../../helpers/custom-prop-types';
import { scrollToWithHeaderHeight } from '../../../helpers/ScrollUtils';
import ColumnComponentTocItem from './ColumnComponentTocItem';
const ColumnComponentToc = (props) => {
    const { isLimit, toc } = props;
    const onClickScroll = useCallback((e) => {
        const { value } = e.currentTarget;
        scrollToWithHeaderHeight(`toc_text_${value}`, { offset: -30 });
    }, []);
    if (toc.length === 0) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: clsx('column_content_toc', isLimit && 'is-limit') }, { children: [_jsx("h2", { children: "\u76EE\u6B21" }), _jsx("ol", { children: toc.map((h2) => (_jsx(ColumnComponentTocItem, { isLimit: isLimit, item: h2, onClick: onClickScroll }, h2.index))) })] })));
};
ColumnComponentToc.propTypes = {
    isLimit: propBool().isRequired,
    toc: propArrayShape().isRequired,
};
export default ColumnComponentToc;
